// extracted by mini-css-extract-plugin
module.exports = {"container":"_3F0KYzEYih5AtH_he8XMtg"};